import { AxiosError } from 'axios'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import * as yup from 'yup'
import { Driver } from 'src/api/models'
import { DateField, MapSelectField, TextField, useForm, usStateMap } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import { handleErrorMessage, Notification } from 'src/components/Notification'
import toast from 'react-hot-toast'

const useStyles = makeStyles(() => ({
  form: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface DriverProps {
  name: string
}

const driverSchema = yup.object().shape({
  first_name: yup.string().required().label('First Name'),
  last_name: yup.string().required().label('Last Name'),
  email: yup.string().email().required().label('Email'),
  phone: yup.string().label('Phone'),
})

interface Props {
  open: boolean
  handleClose: () => void
  onSave?: (driver: Driver) => void
  update?: boolean
  driver?: Driver
}

export const DriverDialog = (props: Props) => {
  const { open, handleClose, onSave, update, driver } = props
  const classes = useStyles()

  const onSubmit = (data: DriverProps) => {
    let func = skuit.sc.drivers.create
    let action = 'creat'
    if (update) {
      func = (data: DriverProps) => skuit.sc.drivers.patch(driver?.guid || '', data)
      action = 'updat'
    }
    func(data)
      .then((newDriver: Driver) => {
        handleClose()
        onSave?.(newDriver)
        toast.success(() => (
          <Notification
            message={`Successfully ${action}ed Driver: ${newDriver.name}`}
            newObject={newDriver}
          />
        ))
      })
      .catch((error: AxiosError) => {
        handleErrorMessage(error, action, 'Driver')
        setApiErrors(formData.setError, error)
      })
  }

  const { Form, data: formData } = useForm(driverSchema)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <Form formProps={{ className: classes.form }} onSubmit={onSubmit}>
        <DialogTitle>{update ? 'Update' : 'Create'} Driver</DialogTitle>
        <DialogContent>
          <TextField name="first_name" label="First Name" defaultValue={driver?.firstName} />
          <TextField name="last_name" label="Last Name" defaultValue={driver?.lastName} />
          <TextField name="email" label="Email" defaultValue={driver?.email} />
          <TextField name="phone" label="Phone" defaultValue={driver?.phone} />
          <MapSelectField name="dl_state_code" label="State" options={usStateMap} defaultValue={driver?.dlStateCode} />
          <TextField name="dl_number" label="Number" defaultValue={driver?.dlNumber} />
          <DateField name="dl_expires_on" label="Expiration" defaultValue={driver?.dlExpiresOn} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
